'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    exports._typeof_1 = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    exports._typeof_1 = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

exports._typeof_1 = _typeof;

var _typeof$1 = exports._typeof_1;

exports["default"] = _typeof$1;
